import * as types from './types';
import { ReserveAction } from './types';
import { ReserveState } from './state';

const emptyReserveList = {};

export function reserveReducer(reserve: ReserveState = emptyReserveList, action: ReserveAction): ReserveState {
    switch (action.type) {
        case types.SET_RESERVE_LIST_ID: {
            const reserveListId = action.payload;
            return {
                ...reserve,
                activeReservelist: reserveListId
            };
        }

        case types.RESERVE_CLEAR_REQUIRED_SPOC:
            return { ...reserve, requiredSpoc: undefined };

        case types.RESERVE_FETCH_REQUIRED_SPOC_SUCCESS: {
            const spoc = action.payload;
            return { ...reserve, requiredSpoc: spoc };
        }

        default:
            return reserve;
    }
}
